// extracted by mini-css-extract-plugin
export default {"RulesOfPay":"RulesOfPay_RulesOfPay__lxis6","head":"RulesOfPay_head__Dj+98"};